module.exports = __webpack_public_path__ + "img/LT.2e48afbc.png";